import { usePreferences } from "../../contexts/PreferencesContext";
import React, { useEffect, useRef, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { FaListAlt, FaPlus, FaVideo } from "react-icons/fa";
import { MdDelete, MdFileDownload, MdInfo, MdModeEdit, MdVideoLibrary } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import Search from "../ReusableComponents/Search";

import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import Request from "../../Request";
import Pagination from '@material-ui/lab/Pagination';
import { BsFillEyeFill } from "react-icons/bs";
import { logout } from "../../actions/AppActions";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress, Zoom } from "@material-ui/core";
import moment from "moment";
import { saveAs } from 'file-saver';
import ModalCandidatosCsv from "./ModalCandidatosCsv";

const hasTrustPoints = (value) => value !== null && value !== undefined;


const CandidatosVinculados = (props) => {const { t } = usePreferences();

  const [lesson_cards, SetLessonCards] = useState(null);
  const [loading_screen, setLoadingScreen] = useState(true);
  const [loading_candidatos, setLoadingcandidatos] = useState(false);
  const [search_oficial, setSearchOficial] = useState('');

  const [candidatos, setcandidatos] = useState([]);
  const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });



  const [search, setSearch] = useState('');
  const { processo_id, processo_name, online } = props;
  const [show_warning, setShowWarning] = useState(false);
  const [candidatos_id, setRedacaoId] = useState(null);


  const [questaoSelect, setQuestaoSelect] = useState({});

  const [showModal, setShowModal] = useState(false);
  let refs = [];
  const dispatch = useDispatch();

  const [loading_zip, setLoadingZip] = useState(false);
  const [message_zip, setMessageZip] = useState('');

  const [loading_zip2, setLoadingZip2] = useState(false);
  const [message_zip2, setMessageZip2] = useState('');
  const timerRef = useRef(null);

  const user = useSelector((state) => state.AppReducer.user);



  const Getcandidatos = async (page, search) => {

    let response = await Request.Get(`faculdade/get_candidatos_vinculados/${processo_id}?page=${page}&search=${search}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    console.log(search);
    console.log(search_oficial);
    console.log(page);


    if (response.pagination.current_page == page) {

      setcandidatos(response.candidatos);

      setPagination(response.pagination);
      props.setState({total_candidates:response.pagination.total_pages})
      setLoadingScreen(false);
      setLoadingcandidatos(false);


    }
  };

  const GetCandidatosZip = async () => {

    let response = await Request.Get(`faculdade/get_relatorios_candidatos/${processo_id}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    // else if(response['status']==undefined){
    //     setLoadingZip(false);

    //     saveAs(response,'provas_processo_'+processo_name+'.zip');
    // }
    else {
      if (response['status'] == true) {
        document.getElementById('download_link').href = response['path'];
        document.getElementById('download_link').click();
        setLoadingZip(false);
        setMessageZip('');

        return;
      } else
      if (response['status'] != 'Error') {
        setMessageZip(response['message']);
      }
      timerRef.current = setTimeout(() => {
        GetCandidatosZip();
      }, 20000);

    }
  };

  const GetVideoCandidato = async (user) => {

    let response = await Request.GetFile(`faculdade/get_video_candidato/${processo_id}/${user.id}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }

    saveAs(response, 'video_' + user.name + '.zip');

  };


  const GetRelatórioCandidato = async (user) => {

    let response = await Request.GetFile(`faculdade/get_relatorio_candidato/${processo_id}/${user.id}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }

    saveAs(response, 'relatorio_' + user.name + '.csv');

  };

  const DeleteRedacao = async (candidatos_id) => {

    let response = await Request.Delete(`faculdade/desvincular_candidato/${candidatos_id}/${processo_id}`);
    console.log(response);
    if (response === undefined) return;

    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    Getcandidatos(pagination.current_page, search_oficial);



  };

  useEffect(() => {
    Getcandidatos(1, search_oficial);

    return () => {
      clearTimeout(timerRef.current);
    };
  }, []);

  const GetPdfsZip = async () => {

    let response = await Request.Get(`faculdade/download_pdfs_images/` + processo_id);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    // else if(response['status']==undefined){
    //     setLoadingZip(false);

    //     saveAs(response,'redacoes_processo_'+processo_name+'.zip');
    // }
    else {
      if (response['status'] == true) {
        document.getElementById('download_link').href = response['path'];
        document.getElementById('download_link').click();
        setLoadingZip2(false);
        setMessageZip2('');

        return;
      } else
      if (response['status'] != 'Error') {
        setMessageZip2(response['message']);
      }
      timerRef.current = setTimeout(() => {
        GetPdfsZip();
      }, 20000);

    }


  };

  let pesquisarTimeout = null;
  const history = useHistory();
  return (
    <>

            <a id="download_link" target="_blank"></a>


            {/* <hr /> */}
            {loading_screen == false && <div className="module-card-container">

                <ModalCandidatosCsv
          onFinish={() => {
            setLoadingcandidatos(true);
            Getcandidatos(1, search_oficial);
          }}
          faculdade={props.faculdade}
          showModal={showModal}
          setShowModal={(e) => setShowModal(e)}
          processo_id={processo_id}
          processo_name={processo_name} />


                <div className="module-breadcrumb">

                    <button
            className="breadcrumb-back"
            onClick={() =>
            props.setState({
              activeTab: -1
            })
            }>{t("dashboard")}


          </button>

                    <span>/</span>

                    <strong>{t("candidates")}</strong>

                </div>

                <div className="module-title-row">

                    <div>

                        <h3 style={{ fontWeight: 'bold' }}>{`
                            ${t("candidates")}
                        `}</h3>

                        <p>{`
                            ${t("legacy_gerencie_os_candidatos_vinculados_ao_processo")}
                        `}</p>

                    </div>

                    <button
            className="btn-dashboard-modern"
            onClick={() =>
            props.setState({
              activeTab: -1
            })
            }>{`
                        ${t("legacy_dashboard")}
                    `}
          </button>

                </div>
                {/* <h4 className="mt-0 header-title" style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>Questões</h4> */}
                {/* <br /> */}

                <div className="module-toolbar">

                    <Search
            placeholder={t("legacy_pesquisar_pelo_nome_do_candidato")}
            ValueChange={(value) => {

              clearTimeout(pesquisarTimeout);

              setSearchOficial(value);

              pesquisarTimeout = setTimeout(() => {

                let page = { ...pagination };

                page.current_page = 1;

                setPagination(page);

                setLoadingcandidatos(true);

                Getcandidatos(1, value);

              }, 500);

            }} />


                    <div className="module-actions">

                        {online === true &&
            user?.empresa?.online_proccess === true &&

            <button
              className="btn-module-secondary"
              disabled={loading_zip}
              onClick={() => {

                if (!loading_zip) {

                  setLoadingZip(true);

                  setMessageZip(t("loading_generating_zip"));

                  GetCandidatosZip();

                }

              }}>


                                {!loading_zip ?
              <><MdFileDownload />{` ${t("legacy_relatorios")}`}</> :
              <><CircularProgress size={16} /> ZIP...</>
              }

                            </button>

            }

                        {online === true &&
            user?.empresa?.online_proccess === true &&

            <button
              className="btn-module-secondary"
              disabled={loading_zip2}
              onClick={() => {

                if (!loading_zip2) {

                  setLoadingZip2(true);

                  setMessageZip2(t("loading_generating_zip"));

                  GetPdfsZip();

                }

              }}>


                                {!loading_zip2 ?
              <><MdFileDownload /> {t("label_images")}</> :
              <><CircularProgress size={16} /> ZIP...</>
              }

                            </button>

            }

                        <Link
              to={`/candidatos_vinculados/register/${processo_id}`}
              className="btn-module-primary">


                            <FaPlus />{`

                            ${t("action_add")}

                        `}</Link>

                        <button
              className="btn-module-secondary"
              onClick={() => {

                setShowModal(true);

              }}>


                            <FaListAlt />

                            {t("action_import_csv")}

                        </button>

                    </div>

                </div>

                <div className="table-modern-card">
                    <table id="tech-companies-1" className="table table-striped">
                        <thead>
                            <tr>

                                <th>{t("label_name")}</th>
                                <th>{t("label_email")}</th>
                                <th>{t("legacy_cpf")}</th>
                                <th>{t("legacy_numero_de_inscricao_2")}</th>
                                <th>{t("legacy_data_de_nascimento")}</th>
                                <th><OverlayTrigger
                    placement="top"
                    overlay={
                    <Tooltip id={`tooltip`}>{t("ui_quanto_menor_mais_confiavel_46a756c2")}

                    </Tooltip>
                    }>

                                    <div className="d-flex justify-content-between align-items-center">{`
                                        ${t("title_reliability")} `}<MdInfo style={{ marginLeft: 5 }} />
                                    </div>
                                </OverlayTrigger> </th>

                                <th data-priority="3">{t("label_actions")}</th>

                            </tr>
                        </thead>
                        <tbody>
                            {loading_candidatos == false && candidatos.map((item, id) =>

              <tr key={id}>
                                    <td>

                                        <div className="redacao-name">

                                            <strong>
                                                {item.name}
                                            </strong>

                                        </div>

                                    </td>
                                    <td>

                                        <div className="redacao-preview">

                                            {item.email}

                                        </div>

                                    </td>
                                    <td>

                                        <div className="redacao-preview">

                                            {item.cpf}

                                        </div>

                                    </td>
                                    <td>

                                        <div className="redacao-preview">

                                            {item.numero_inscricao || '-'}

                                        </div>

                                    </td>
                                    <td>
                                        <div className="redacao-preview">
                                            {moment(item.nascimento).format('DD/MM/YYYY')}
                                        </div>
                                    </td>
                                    <td>

                                        <span
                    className={`trust-badge ${!hasTrustPoints(item.trust_points) ?
                    'trust-neutral' : item.trust_points <= 20 ?
                    'trust-low' :
                    item.trust_points <= 50 ?
                    'trust-medium' :
                    'trust-high'}`
                    }>


                                            {hasTrustPoints(item.trust_points) ? Number(item.trust_points).toFixed(2).replace('.', ',') : t("label_not_calculated")}

                                        </span>

                                    </td>

                                    {/* <td><img style={{ height: 60, width: 60, objectFit: 'contain' }} src={STORAGE_URL + STORAGE_URL + item.arquivo} /></td> */}

                                    <td>

                                        <div className="actions-group">

                                            <Link
                      to={`/candidatos_vinculados/show/${item.id}/${processo_id}`}>


                                                <button
                        className="action-btn warning">

                                                    <BsFillEyeFill />
                                                </button>

                                            </Link>

                                            <button
                      className="action-btn info"
                      onClick={() => {

                        GetRelatórioCandidato(item);

                      }}>

                                                <MdFileDownload />
                                            </button>

                                            <button
                      className="action-btn success"
                      onClick={() => {

                        GetVideoCandidato(item);

                      }}>

                                                <MdVideoLibrary />
                                            </button>

                                            {item.deleted_at == null &&

                    <button
                      className="action-btn danger"
                      onClick={() => {

                        setRedacaoId(item.id);

                        setShowWarning(true);

                      }}>

                                                    <MdDelete />
                                                </button>

                    }

                                        </div>

                                    </td>
                                </tr>
              )}

                        </tbody>
                    </table>
                    {loading_candidatos == true &&
          <div className="row" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                            {/* <div className="spinner-border text-primary" role="status"  >
                </div> */}
                            <CircularProgress />
                        </div></div>

          }
                </div>
                {loading_candidatos == false && candidatos.length == 0 && <div className="empty-module">

                    <div className="empty-module-icon">
                        👤
                    </div>

                    <h3>{`
                        ${t("empty_no_candidate_found")}
                    `}</h3>

                    <p>
                        Adicione o primeiro candidato ao processo.
                    </p>

                </div>}

                <Pagination
          className={pagination.last_page == 1 ? "hide" : ""}
          style={{ display: "flex", justifyContent: "flex-end" }}
          count={pagination.last_page}
          value={pagination.current_page}
          onChange={(_, value) => {
            setLoadingcandidatos(true);
            console.log(_, value);
            let page = { ...pagination };
            page.current_page = value;
            setPagination(pagination);
            Getcandidatos(value, search_oficial);
          }} />


                {/* {this.state.andamento == true && <AvaliacaoAndamento get_candidatos={this.get_candidatos.bind(this)} {...this.props} />} */}

            </div>}

            {loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                {/* <div className="spinner-border text-primary" role="status"  >
            </div> */}
                <CircularProgress />
            </div></div>}

            <SweetAlert
        warning
        title={t("legacy_atencao")}
        onConfirm={() => {
          setShowWarning(false);
          setLoadingcandidatos(true);
          DeleteRedacao(candidatos_id);
          // this.delete_banner(this.state.banner_to_delete);
        }}
        onCancel={() => {
          setShowWarning(false);
        }}
        show={show_warning}
        confirmBtnText={t("ui_sim_desejo_desvincular_91364237")}
        cancelBtnText={t("legacy_cancelar")}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        showCancel={true}>{t("ui_ao_desvincular_este_candidato_ele_nao_tera_mais_ac_1d2c882c")}


      </SweetAlert>



        </>);

};

export default CandidatosVinculados;
